import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import {
  COVER_AND_REPORT_LAYOUT,
  QC_LAYOUT,
  SUMMARY_LAYOUT,
  REPORT_ONLY_LAYOUT,
  REPORT_DESCRIPTIONS,
  REPORT_DISPLAY_NAMES,
  TITLE_BASIC_LAYOUTS_BLOCK,
  DESCRIPTIONS_BASIC_LAYOUTS_BLOCK,
} from '../../../constants/reportLayouts';
import ReportLayoutInfo from '../ReportLayoutInfo';

class ReportLayouts extends React.Component {
  static get propTypes() {
    return {
      layouts: PropTypes.array,
      companyId: PropTypes.string,
      TemplateOptions: PropTypes.node,
    };
  }

  renderLayout(reportType, link) {
    const { layouts, companyId } = this.props;
    const layout = layouts[reportType];
    const { templates } = layout;

    return (
      <ReportLayoutInfo
        name={REPORT_DISPLAY_NAMES[reportType]}
        link={link}
        companyId={companyId}
        description={REPORT_DESCRIPTIONS[reportType]}
        standardTemplate={templates.find(({ type }) => type === 'Standard')}
        lowTemplate={templates.find(({ type }) => type === 'Low')}
        moderateTemplate={templates.find(({ type }) => type === 'Moderate')}
        highTemplate={templates.find(({ type }) => type === 'High')}
      />
    );
  }

  render() {
    return (
      <div>
        {this.renderLayout(QC_LAYOUT, `/layouts/qcreport`)}
        <h5 className="px-1 mx-3 mt-5 mb-2">{TITLE_BASIC_LAYOUTS_BLOCK}</h5>
        <Row>
          <Col className="ml-3">
            <div className="px-1">
              <span>{DESCRIPTIONS_BASIC_LAYOUTS_BLOCK}</span>
              <a href="https://standards.aarst.org/MAH-2019/index.html" target="_blank" rel="noopener noreferrer">
                Click here to review standard.
              </a>
            </div>
          </Col>
          <Col md={6}>{this.props.TemplateOptions}</Col>
        </Row>
        {this.renderLayout(COVER_AND_REPORT_LAYOUT, `/layouts/coverandreport`)}
        {this.renderLayout(REPORT_ONLY_LAYOUT, `/layouts/reportonly`)}
        {this.renderLayout(SUMMARY_LAYOUT, `/layouts/summaryreport`)}
      </div>
    );
  }
}

export default ReportLayouts;



// WEBPACK FOOTER //
// src/components/reportManagement/ReportLayouts/index.jsx